import * as React from 'react';

const ArrowUpSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        className="arrow-up_svg__eds-icon--up-arrow_svg"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            className="arrow-up_svg__SVGID_1_"
            d="M12 4l-.2.2L6 9.8l.7.8 4.8-4.7V20h1V5.9l4.8 4.7.7-.7z"
        />
    </svg>
);

ArrowUpSvg.displayName = 'ArrowUpSvg';
export default ArrowUpSvg;
